import { DATA_TYPES } from 'constants/common';

// field views
import { inputField as InputField } from 'ui/views/generic/inputField';
import { textareaField as TextareaField } from 'ui/views/generic/textareaField';
import { dateField as DateField } from 'ui/views/generic/dateField';
import { singleSelectField as SingleSelectField } from 'ui/views/generic/singleSelectField';
import { multiSelectField as MultiSelectField } from 'ui/views/generic/multiSelectField';
import { radioList as RadioList } from 'ui/views/generic/radioList';
import { typeAheadSearchField as TypeAheadSearchField } from 'ui/views/generic/typeAheadSearchField';
import { TimeField } from 'modules/TimeField';
import { radioListField as RadioListField } from 'ui/views/generic/radioListField';
import { DateTimeSelection } from 'modules/DateTimeSelection';
import { DrugIntakeSelection } from 'modules/DrugIntakeSelection';
import { RejectSelection } from 'modules/RejectSelection';
import { multiSelectFormField as MultiSelectFormField } from 'ui/views/generic/multiSelectFormField';
import { singleSelectWithStaticDesc as SingleSelectWithStaticDesc } from 'ui/views/generic/singleSelectWithStaticDesc';
import { FormSection } from 'ui/containers/FormSection';
import { sectionTitle as SectionTitle } from 'ui/views/generic/sectionTitle';
import { inputFieldCheckbox as InputFieldCheckbox } from 'ui/views/generic/inputFieldCheckbox';

// import { DateField } from 'ui/containers/DateField';

/**
 * @desc Return a field view according to the field type.
 * @example
 * import { getFieldView } from 'resolvers/form';
 */
export const getFieldView = ( type = DATA_TYPES.TEXT ) => {
    switch( type ) {

        // textarea input
        case DATA_TYPES.TEXTAREA: {
            return TextareaField;
        }

        // date input
        case DATA_TYPES.DATE: {
            return DateField;
        }

        // single-select input
        case DATA_TYPES.SINGLE_SELECT: {
            return SingleSelectField;
        }

        // single-select with static description
        case DATA_TYPES.SINGLE_SELECT_STATIC_DESC: {
            return SingleSelectWithStaticDesc;
        }

        // multi-select input
        case DATA_TYPES.MULTI_SELECT: {
            return MultiSelectField;
        }

        // radio list
        case DATA_TYPES.RADIO_LIST: {
            return RadioList;
        }

        // radio list
        case DATA_TYPES.RADIO_FIELD: {
            return RadioListField;
        }

        // radio list
        case DATA_TYPES.SEARCH: {
            return TypeAheadSearchField;
        }

        case DATA_TYPES.TIME: {
            return TimeField;
        }

        case DATA_TYPES.DATE_TIME_SELECT: {
            return DateTimeSelection;
        }

        case DATA_TYPES.DRUG_INTAKE_SELECT: {
            return DrugIntakeSelection;
        }

        case DATA_TYPES.REJECT_SELECT: {
            return RejectSelection;
        }

        case DATA_TYPES.MULTI_SELECT_FIELD: {
            return MultiSelectFormField;
        }

        case DATA_TYPES.FORM_SECTION: {
            return FormSection;
        }

        case DATA_TYPES.SECTION_TITLE: {
            return SectionTitle;
        }

        case DATA_TYPES.INPUT_FIELD_CHECKBOX: {
            return InputFieldCheckbox;
        }

        // text input (default case)
        case DATA_TYPES.TEXT:
        default: {
            return InputField;
        }
    }
};
